import {PurchasePage} from '../purchasePage';
import {ISessionService, SessionInfo} from '../../../services/session';
import {EnvConfig} from '../../../config/envConfig.interface';
import {AuthService} from '../../../services/authService';
import {ITranslateService} from '../../../services/translateService';
import {IUserService} from '../../../services/user';
import {ITrackingService} from '../../../services/gtmHelper';
import {IPurchaseService} from '../../../services/purchase';
import {IBindingService} from '../../../services/bindingService';

export class SuccessPage extends PurchasePage {
  constructor(
    protected configuration: EnvConfig,
    protected authService: AuthService,
    protected translateService: ITranslateService,
    protected sessionService: ISessionService,
    protected userService: IUserService,
    protected trackingService: ITrackingService,
    protected purchaseService: IPurchaseService,
    protected bindingService: IBindingService,
  ) {
    super(
      configuration,
      authService,
      translateService,
      sessionService,
      userService,
      trackingService,
      purchaseService,
      bindingService,
    );
  }
  public render(): void {
    this.trackingService.trackEvent('purchase_success', {}, () => {
      this.trackingService.trackPurchaseEvent(() => {
        this.deletePurchaseSessionData();
      });
    });
  }

  private deletePurchaseSessionData(): void {
    this.sessionService.delete(SessionInfo.purchase_productInfo);
    this.sessionService.delete(SessionInfo.purchase_productInfoV2);
    this.sessionService.delete(SessionInfo.purchase_successfulPaymentInfo);
  }
}
